<template>
	<v-container grid-list-md class="fill-height" fluid>
		<v-row align="center" justify="center">
			<v-col cols="12" sm="8" md="4">
				<app-status-alert
					v-if="verificationLinkSent"
					:message="
						$t(
							'message.a_new_verifcation_link_has_been_sent_to_the_email_address_you_provided_during_registration'
						)
					"
				></app-status-alert>
				<app-error-alert></app-error-alert>
				<v-form>
					<v-card class="elevation-12">
						<v-toolbar color="primary" dark flat>
							<v-toolbar-title class="text-center">
								<v-spacer></v-spacer>
								{{ $t("title.email_verification_required") }}
								<v-spacer></v-spacer
							></v-toolbar-title>
						</v-toolbar>
						<v-card-text>
							<p>
								{{
									$t("message.verify_email_full_description")
								}}
							</p>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<Link
								:href="$route('logout')"
								method="post"
								as="button"
								><v-btn text>{{
									$t("label.logout")
								}}</v-btn></Link
							>
							<v-spacer></v-spacer>
							<v-btn
								color="primary"
								@click.native="submit()"
								:loading="item.processing"
							>
								<v-icon left>mdi-send</v-icon>
								{{ $t("label.resend_verification_email") }}
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
import LayoutGuest from "../../layouts/guest.vue";
export default {
	layout: LayoutGuest,

	components: {
		Link,
	},

	props: {
		status: String,
	},

	data() {
		return {
			item: this.$inertia.form(),
		};
	},

	computed: {
		verificationLinkSent() {
			return this.status === "verification-link-sent";
		},
	},

	methods: {
		submit() {
			this.item.post(this.$route("verification.send"));
		},
	},
};
</script>